import { useState, useEffect, useRef } from "react";
import { getSrcType } from "modules/core/components/VideoPlayer/utils";
import { EventPlayout } from "../types";

export const useEventPlayoutSource = (playout: EventPlayout | undefined) => {
  const [source, setSource] = useState<string>();
  const executedVerifyRef = useRef(false);

  const mediaAssets = playout?.mediaAssets;
  const allBroadcastAssets = mediaAssets?.filter(({ assetType }) =>
    assetType.includes("broadcast")
  );

  const allBroadcastSources = allBroadcastAssets?.reduce<string[]>(
    (sources, { mediaAssetLocators }) => {
      mediaAssetLocators.forEach(({ url }) => sources.push(url));
      return sources;
    },
    []
  );

  useEffect(() => {
    if (!allBroadcastSources) return;
    if (source) return;
    if (executedVerifyRef.current) return;

    executedVerifyRef.current = true;

    const verifySources = async () => {
      for (const url of allBroadcastSources) {
        const isHls = url.endsWith(".m3u8");
        const method: Request["method"] = isHls ? "GET" : "HEAD";

        const { ok } = await fetch(url, { method }).catch(() => ({
          ok: false
        }));

        if (ok) {
          setSource(url);
          continue;
        }
      }
    };

    verifySources();
  }, [allBroadcastSources]);

  return { source, type: getSrcType(source ?? "") };
};
